export default __webpack_public_path__ + "static/media/whistle-icon2.4b6f132d.png";